import { chartColorCode } from './colorCodes';
import moment from 'moment';
import Highcharts from 'highcharts';

export const parseLineChartData = chart => {
  let tickInterval = [];
  Object.keys(chart).forEach(function (key, index) {
    return parseToHighChart(chart, key, tickInterval);
  });
  return { chart, tickInterval };
};

export const parseAreaChartData = chart => {
  let tickInterval = [];
  let indexOfTotal = -1;
  Object.keys(chart).forEach(function (key, index) {
    if (chart[key]['category'] === 'total') indexOfTotal = index;
    if (chart[key]['category'] !== 'total') {
      return parseToHighChart(chart, key, tickInterval);
    }
  });
  if (indexOfTotal !== -1) chart.splice(indexOfTotal, 1);
  return { chart, tickInterval };
};

const parseToHighChart = (chart, key, tickInterval) => {
  chart[key].data.map(function (value, keys, index) {
    chart[key]['name'] = chart[key]['category'];
    chart[key]['marker'] = {
      fillColor: 'transparent',
    };
    chart[key]['color'] = chartColorCode[chart[key]['category']];
    chart[key]['fillColor'] = {
      linearGradient: [0, 0, 0, 300],
      stops: [
        [
          0,
          Highcharts.Color(chartColorCode[chart[key]['category']])
            .setOpacity(0.5)
            .get('rgba'),
        ],
        [
          1,
          Highcharts.Color(chartColorCode[chart[key]['category']])
            .setOpacity(0)
            .get('rgba'),
        ],
      ],
    };
    chart[key].data[keys][0] = moment.utc(value[0]).valueOf();
    tickInterval.push(chart[key].data[keys][1]);
    return value;
  });
  return chart[key];
}

export const getYAxisTickInterval = (chartData, axisPointLimit) => {
  if (chartData.tickInterval.length) {
    let padEnd = getPaddingMaxLengthForYAxisTickInterval(chartData);
    if (Math.max(...chartData.tickInterval).toString()[0] === '9') {
      padEnd = getPaddingMaxLengthForYAxisTickInterval(chartData) + 1;
    }
    return Number(
      (Number(Math.max(...chartData.tickInterval).toString()[0]) + 1)
        .toString()
        .padEnd(
          padEnd, 0
        ) / axisPointLimit,
    );
  }
  return 1000;
}

export const getPaddingMaxLengthForYAxisTickInterval = chartData => {
  let maxValueInChartData = Math.max(...chartData.tickInterval);
  let maxValueInChartDataInteger = Math.round(maxValueInChartData);
  let paddingMaxLength = maxValueInChartDataInteger.toString().length;
  return paddingMaxLength;
}



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/HighChartUtils.js